export default {
    appId: '954L8Y24XO',
    apiKey: '7b1e36de2bf2983e14fd1b0bd99886cf',
    winesIndex: 'wines',
    winesNameIndex: 'wines_name_asc',
    winesPriceIndex: 'wines_price_asc',
    storesIndex: 'stores',
    recipesIndex: 'recipes'
};